var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3acce1;}.b{fill:#e72369;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M75.633,82.818l-5.9-5.9A33.858,33.858,0,0,0,74.067,60.59v-.624H77.2V56.833H74.067v-14.1A1.566,1.566,0,0,0,72.5,41.167H61.533v-9.4A1.566,1.566,0,0,0,59.967,30.2h-4.7V25.5a23.5,23.5,0,0,0-47,0v4.7h-4.7A1.566,1.566,0,0,0,2,31.767v47A7.842,7.842,0,0,0,9.833,86.6h25.8a53.877,53.877,0,0,0,12.635,9.215,1.562,1.562,0,0,0,1.474,0A49.751,49.751,0,0,0,68.065,79.678l5.353,5.355H67.8v3.133h9.4A1.566,1.566,0,0,0,78.767,86.6V77.2H75.633Zm-4.7-22.228A30.534,30.534,0,0,1,67.421,74.6l-2.729-2.729a34.563,34.563,0,0,0,3.025-11.91h3.216Zm-6.267-3.757H49a1.566,1.566,0,0,0-1.108,2.674l13,13A31.46,31.46,0,0,1,49,84.8,31.481,31.481,0,0,1,33.333,57.571v-7H64.667ZM52.782,59.967H64.568a31.46,31.46,0,0,1-2.25,9.535ZM11.4,25.5a20.367,20.367,0,0,1,40.733,0v4.7h-4.7V25.5a15.667,15.667,0,0,0-31.333,0v4.7H11.4Zm32.9,4.7H19.233V25.5a12.533,12.533,0,0,1,25.067,0ZM5.133,59.967h9.4v4.7h-9.4Zm9.4-3.133h-9.4v-4.7h9.4ZM5.133,67.8h9.4v4.7h-9.4Zm9.4-18.8h-9.4V44.3h9.4Zm-4.7,34.467a4.706,4.706,0,0,1-4.7-4.7V75.633H16.1a1.566,1.566,0,0,0,1.567-1.567V42.733A1.566,1.566,0,0,0,16.1,41.167H5.133V33.333H58.4v7.833H25.5a1.566,1.566,0,0,0-1.567,1.567V60.59c0,8.181,3.157,16.088,8.83,22.876ZM49,92.65c-13.751-7.6-21.933-19.528-21.933-32.06V44.3H70.933V56.833H67.8V49a1.566,1.566,0,0,0-1.567-1.567H31.767A1.566,1.566,0,0,0,30.2,49v8.57A34.618,34.618,0,0,0,48.25,87.976a1.569,1.569,0,0,0,1.5,0A34.59,34.59,0,0,0,63.194,74.809l2.6,2.6A45.984,45.984,0,0,1,49,92.65Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3,
    height: 3,
    transform: "translate(80 57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 3,
    transform: "translate(87 57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 3,
    transform: "translate(93 57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 3,
    transform: "translate(87 15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 3,
    transform: "translate(93 15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M68.5,22.1H50.349l3.592-3.592-2.215-2.215L45.459,22.56a1.565,1.565,0,0,0,0,2.215l6.267,6.267,2.215-2.215-3.592-3.592H68.5Z",
    transform: "translate(24.367 8.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M58.941,27.508l-2.215-2.215L50.459,31.56a1.565,1.565,0,0,0,0,2.215l6.267,6.267,2.215-2.215-3.592-3.592H68.8V31.1H55.349Z",
    transform: "translate(27.2 13.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.726,21.042l2.215-2.215-3.592-3.592H62.5V12.1H44.349l3.592-3.592L45.726,6.293,39.459,12.56a1.565,1.565,0,0,0,0,2.215Z",
    transform: "translate(20.967 2.433)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.e6786955848ae56cb7bae6b5fcf9bc41.svg";
export { ForwardRef as ReactComponent };